import { render, staticRenderFns } from "./DSxDetailsSymptomsPage.vue?vue&type=template&id=17d37647"
import script from "./DSxDetailsSymptomsPage.vue?vue&type=script&lang=js"
export * from "./DSxDetailsSymptomsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports